import { Component, Input, OnInit, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DataType, DataTypeAvailableOptions } from '@core/constants/data-types.constants';

@Component({
  selector: 'mfp-select-radio',
  templateUrl: './select-radio.component.html',
  styleUrls: ['./select-radio.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectRadioComponent),
      multi: true
    }
  ]
})
export class SelectRadioComponent implements ControlValueAccessor {
  @Input() view = 'agent';
  @Input() color: 'primary' | 'light' = 'primary';
  @Input() label = '';
  @Input() name = '';
  @Input() placeholder = '';
  @Input() options: DataTypeAvailableOptions = [];
  @Input() required = false;
  @Input() readonly = false;
  @Input() disabled = false;
  @Input() success = false;
  @Input() error = false;
  @Input() helper = '';
  @Input() labelSize: 'medium' | 'large' = 'medium';
  @Input() full = false;

  private innerValue: DataType = '';

  private onChangeCallback = (_: DataType) => {};
  private onTouchCallback = () => {};

  constructor() {}

  get value(): DataType {
    return this.innerValue;
  }

  set value(newValue: DataType) {
    if (newValue !== this.innerValue) {
      this.innerValue = newValue;
      this.onChangeCallback(newValue);
      this.onTouchCallback();
    }
  }

  writeValue(value: DataType): void {
    this.value = value;
  }

  registerOnChange(fn: (_: DataType) => void): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouchCallback = fn;
  }
}
